import React, { useCallback } from 'react'
import cn from 'classnames'
import { DropdownItem } from 'util/ui'
import { angleRightB as RightArrowIcon } from 'assets/icons/groove/v2'

const PresenceDropdownSettingsItem = React.memo(props => {
  const { presence, className, onClick, ...rest } = props
  const handleClick = useCallback(
    () => {
      if (onClick) onClick(presence)
    },
    [onClick, presence]
  )

  return (
    <DropdownItem
      className={cn(className, 'settings')}
      aria-checked="false"
      onClick={handleClick}
      {...rest}
    >
      <div className="leftcol">&nbsp;</div>
      <div className="rightcol">
        <div className="name">Auto-away settings</div>
        <div className="icon">
          <RightArrowIcon />
        </div>
      </div>
    </DropdownItem>
  )
})

export default PresenceDropdownSettingsItem
